import { CITATIONS_TAG } from '../classnames/scientific-citations';
import CitationIndexComponent from './citation-index-component';

export default class CitationIndexesRenderer {
  citationIndexes = document.querySelectorAll(CITATIONS_TAG);
  citationsDB = window.citationsDB;
  processedCitationIds = [];

  createCitationIndex = ({ index, id, prependComma = false }) => (
    (new CitationIndexComponent({ index, id, prependComma })).render()
  );

  createCitationIndexes = (citationIds) => citationIds.map(
    (id, index) => {
      if (this.processedCitationIds.indexOf(id) < 0) {
        this.processedCitationIds.push(id);
      }
      const citationIndex = this.processedCitationIds.indexOf(id) + 1;
      return this.createCitationIndex({ index: citationIndex, id, prependComma: index !== 0 });
    }
  );

  getCitationIds = (citationIndexesElement) => {
    const citationIds = citationIndexesElement.innerHTML.split(',').map((id) => id.trim());
    // NOTE: Filter only existing citation ids in case of typo or citation removal.
    return citationIds.filter((id) => this.citationsDB[id]);
  };

  renderCitationIndexes = (citationIndexesElement) => {
    const citationIds = this.getCitationIds(citationIndexesElement);
    const citationsParent = citationIndexesElement.parentElement;
    const newCitationIndexesElements = this.createCitationIndexes(citationIds);

    newCitationIndexesElements.forEach((node) => citationsParent.insertBefore(node, citationIndexesElement));
    citationsParent.removeChild(citationIndexesElement);
  };

  render = () => {
    this.citationIndexes.forEach(this.renderCitationIndexes);
    return this.processedCitationIds;
  };
}
